import React from "react";
import Box from "@material-ui/core/Box";
import ButtonBase from "@material-ui/core/ButtonBase";

import TextJamLogo from "@/images/TextJam_logo.svg";
import BlockJamLogo from "@/images/BlockJam_logo.svg";

import CodeJamSelectProjectAction from "./CodeJamSelectProjectAction";

import { Modal } from "../../../../components/modals/modal";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@/images/close.svg";
import ArrowLeftIcon from "@/images/arrow-left-chevron.svg";

import { IDE_TYPE } from "../model/ide.types";
import { useStyles } from "../styles/CodeJamModal.styles";

// onBack is optional: when provided (the Clubs instance, where the user came
// here from the BlockJam/TextJam picker), the header shows a
// "Previous Options" button leading back to the picker.
const CodeJamModal = ({ isOpen, onClose, push, onBack, ideType = IDE_TYPE.TEXT_JAM }) => {
  const classes = useStyles();

  const isTextJam = ideType === IDE_TYPE.TEXT_JAM;
  const logo = isTextJam ? TextJamLogo : BlockJamLogo;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        classes: {
          rounded: classes.paperRounded,
        },
      }}
    >
      <div className={classes.dialogBoxInternal}>
        <Box className={classes.headerContainer}>
          <div className={classes.headerSide}>
            {onBack && (
              <ButtonBase
                focusRipple
                aria-label="back"
                className={classes.backBtn}
                onClick={onBack}
              >
                <img
                  alt="Back icon"
                  className={classes.backBtnIcon}
                  src={ArrowLeftIcon}
                />
                <span className={classes.backBtnText}>Previous Options</span>
              </ButtonBase>
            )}
          </div>
          <img
            alt={isTextJam ? "TextJam Logo" : "BlockJam Logo"}
            className={classes.codeJamItemLogo}
            src={logo}
          />
          <div className={`${classes.headerSide} ${classes.headerSideEnd}`}>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              className={classes.closeBtn}
              onClick={onClose}
            >
              <img
                alt="Close icon"
                className={classes.closeBtnIcon}
                src={CloseIcon}
              />
            </IconButton>
          </div>
        </Box>
        <CodeJamSelectProjectAction push={push} onClose={onClose} ideType={ideType} />
      </div>
    </Modal>
  );
};

export default CodeJamModal;
